<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-toolbar
            flat
          >
            <v-toolbar-title>Inscritos por día</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="consultar()" small tile>Consultar</v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  clearable
                  v-model="fechaini"
                  type="date"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  label="Fecha final"
                  filled
                  dense
                  clearable
                  v-model="fechafin"
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

        	<v-card class="shadowCard" v-if="visibleFast">
        		<v-card-title primary-title>
        		  Fast
              <v-spacer></v-spacer>
              <v-btn 
	              class="mr-2" 
	              small dark color="green"
	              @click="exportExcel( dataTablaFastDos  , 'inscritos_fast')"
	              tile
	            >
	              <v-icon small>mdi-microsoft-excel</v-icon>
	            </v-btn>
        		</v-card-title>
        	  <v-card-text>
  		      	<v-data-table
  		          :headers="headersDos"
  		          :items="dataTablaFastDos"
  		          class="elevation-0"
  		          dense
  		          mobile-breakpoint="200"
                :search="searchFast"
  		        >
  		          <template v-slot:item.costo_curso="{ item }">
  		            {{ formatMonto(item.costo_curso) }}
  		          </template>
  		          <template v-slot:item.monto_pagado_en_ese_grupo="{ item }">
  		            {{ formatMonto(item.monto_pagado_en_ese_grupo) }}
  		          </template>
  		          <template v-slot:item.comision="{ item }">
  		            {{ formatMonto(item.comision) }}
  		          </template>
  		          <template v-slot:no-data>
  		            <v-btn
  		              color="primary"
  		              @click="initialize"
  		              small
  		            >
  		              Actualizar
  		            </v-btn>
  		          </template>
  		        </v-data-table>
        	  </v-card-text>
        	</v-card>

          <v-divider></v-divider>

          <v-card class="shadowCard" v-if="visibleInbi">
            <v-card-title primary-title>
              Inbi
              <v-spacer></v-spacer>
              <v-btn 
	              class="mr-2" 
	              small dark color="green"
	              @click="exportExcel( dataTablaInbiDos  , 'inscritos_inbi')"
	              tile
	            >
	              <v-icon small>mdi-microsoft-excel</v-icon>
	            </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headersDos"
                :items="dataTablaInbiDos"
                class="elevation-0"
                dense
                mobile-breakpoint="200"
                :search="searchInbi"
              >
                <template v-slot:item.costo_curso="{ item }">
                  {{ formatMonto(item.costo_curso) }}
                </template>
                <template v-slot:item.monto_pagado_en_ese_grupo="{ item }">
                  {{ formatMonto(item.monto_pagado_en_ese_grupo) }}
                </template>
                <template v-slot:item.comision="{ item }">
                  {{ formatMonto(item.comision) }}
                </template>
                <template v-slot:no-data>
                  <v-btn
                    color="primary"
                    @click="initialize"
                    small
                  >
                    Actualizar
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';
  import XLSX from 'xlsx'
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import validarErrores  from '@/mixins/validarErrores'

  import Vue from 'vue'

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      snackbar:false,
      headers: [
        { text: 'Sucursal'                 , value: 'plantel' },
        { text: 'Alumnos dia anterior'     , value: 'alumnodia' },
        // { text: 'Hoy'                      , value: 'alumnoDiaHoy' },
        { text: 'Acumulado semana'         , value: 'alumnosemana' },
        { text: 'Acumulado'                , value: 'totalAcumulado' },
      ],

      headersDos: [
        { text: 'ID'               , value: 'id_alumno' },
        { text: 'Matrícula'        , value: 'matricula' },
        { text: 'Grupo'            , value: 'grupo' },
        { text: 'Ciclo'            , value: 'ciclo' },
        { text: 'Curso'            , value: 'curso' },
        { text: 'Costo curso'      , value: 'costo_curso', align: 'end' },
        { text: 'F. Primer Pago'   , value: 'primer_pago' },
        { text: 'F. Ultimo Pago'   , value: 'ultimo_pago_en_ese_grupo' },
        { text: 'Pagos Totales'    , value: 'total_pagos_en_ese_grupo' },
        { text: 'Monto pagado'     , value: 'monto_pagado_en_ese_grupo', align: 'end' },        { text: 'Comisión'         , value: 'comision', align: 'end' },
      ],
      desserts: [],
      ciclos:[],
      cicloInf:null,
      cicloSup:null,
      plantel:null,
      cicloAnterior:[],
      cicloSiguiente:[],

      dataTablaFastDos:[],
      dataTablaInbiDos:[],

      dialogCarga:false,
      fast:{},
      inbi:{},

      fechaini:null,
      fechafin:null,
      totalFast:0,
      totalInbi:0,

      visibleFast: true,
      visibleInbi: true,
      searchFast:'',
      searchInbi:'',
    }),

    watch: {
      cicloInf () {
        if(this.cicloInf){
          var num_search = parseInt(this.cicloInf.ciclo.substr(5,3)) + 1
          for(const i in this.ciclos){
            var cadena_search = this.ciclos[i].ciclo.substr(0,8)
            if (cadena_search.search(num_search) != -1) {
              this.cicloSup = this.ciclos[i]
            }
          }
        }
      }
    },

    created () {
      if(this.getdatosUsuarioERPERP.idpuesto == 18 ){
        this.visibleFast =  this.getEscuela == 1 ? false : true 
        this.visibleInbi =  this.getEscuela == 1 ? true  : false 
      }

      if( this.getdatosUsuarioERPERP.iderp == 568 ){
        this.visibleFast =  true 
        this.visibleInbi =  true
      }

      this.initialize()
    },

    computed:{
      ...mapGetters('login', [ 'getdatosUsuarioERPERP', 'getEscuela' ])
    },

    methods: {
      initialize () {
        this.cargar = true
        this.ciclos = []
        this.planteles = []
        this.$http.get('kpi.ciclos.all').then(response=>{
          for(const i in response.data){
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              if(response.data[i].ciclo.search('CICLO') != -1){
                this.ciclos.push(response.data[i])
              }
            }
          }
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
        
      },

      consultar () {
        this.getRango()
      },

      formatMonto (valor) {
        const n = Number(valor)
        if (isNaN(n)) return ''
        return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
      },

      getRango () {
        this.dataTablaFastUno = []
        this.dataTablaInbiUno = []
        this.dialogCarga = true

        var payload = {
          fechaini: this.fechaini,
          fechafin: this.fechafin
        }

        this.$http.post('kpi.inscripciones.dia',payload).then(response=>{
          // Guardar los datos 
          this.dataTablaFastDos = response.data.fast
          // Guardar los datos 
          this.dataTablaInbiDos = response.data.inbi
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      exportar(){
        this.exportExcel()
      },

      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      exportExcel(){
        let resultado = this.dataTablaFastDos.concat(this.dataTablaInbiDos)

        let data = XLSX.utils.json_to_sheet(resultado)
        const workbook = XLSX.utils.book_new()
        const filename = 'KPI'
        XLSX.utils.book_append_sheet(workbook, data, filename)

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
        
        let formData = new FormData();
        // //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file',file);
        // /*getDatosRiesgo the form data*/

        this.$http.post('pdfs',formData).then(response=> {
          window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          alert(error.body)
          console.log(error);
        });

      },      
    },
  }
</script>